var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleAngleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.161,
    height: 18.609,
    viewBox: "0 0 20.161 18.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angles-left",
    d: "M3.767,73.28l6.658-6.658a1.551,1.551,0,0,0-2.193-2.193L.479,72.183a1.55,1.55,0,0,0,0,2.193l7.753,7.753a1.547,1.547,0,0,0,2.191,0,1.55,1.55,0,0,0,0-2.193Zm9.306,0,6.658-6.658a1.551,1.551,0,0,0-2.193-2.193L9.786,72.183a1.55,1.55,0,0,0,0,2.193l7.753,7.753a1.52,1.52,0,0,0,1.093.456,1.551,1.551,0,0,0,1.1-2.647Z",
    transform: "translate(-0.025 -63.975)",
    fill: "#d1002a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAngleLeft);
export default __webpack_public_path__ + "static/media/Double-angle-left.32b6f217707f33f48a79187511a7e0f9.svg";
export { ForwardRef as ReactComponent };